import { HttpErrorResponse } from '@angular/common/http';

type ApiErrorBody = Readonly<{
  title?: string;
  detail?: string;
  errors?: Record<string, readonly string[] | string[]>;
}>;

/** Primeira mensagem útil do corpo de erro da API (validação, detail ou title). */
export function getFirstApiErrorMessage(error: HttpErrorResponse): string | undefined {
  const body = error.error as ApiErrorBody | string | null | undefined;
  if (!body || typeof body !== 'object') {
    return undefined;
  }

  const validationErrors = body.errors;
  if (validationErrors && typeof validationErrors === 'object') {
    const keys = Object.keys(validationErrors);
    const firstKey = keys[0];
    if (firstKey) {
      const messages = validationErrors[firstKey];
      const firstMessage = Array.isArray(messages) ? messages[0] : undefined;
      if (typeof firstMessage === 'string' && firstMessage.trim()) {
        return firstMessage.trim();
      }
    }
  }

  if (typeof body.detail === 'string' && body.detail.trim()) {
    return body.detail.trim();
  }

  if (typeof body.title === 'string' && body.title.trim()) {
    return body.title.trim();
  }

  return undefined;
}
